import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'

Vue.use(VueRouter)
Vue.use(Meta)

const routes = [
  {
    path: '/hsn-code',
    component: () => import('@/views/Layout/'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/Home/')
      },
      {
        path: 'chapter/:two',
        name: 'hsTwos',
        component: () => import('@/views/HSNCodeTwoList/')
      },
      {
        path: 'search/:searchQuery',
        name: 'searchResults',
        props: true,
        component: () => import('@/views/SearchResults')
      },
      {
        path: 'listing',
        name: 'listing',
        component: () => import('@/views/ListingPage')
      },
      {
        path: 'listing/:searchQuery',
        name: 'keywordPage',
        props: true,
        component: () => import('@/views/KeywordListing')
      },
      {
        path: ':id',
        name: 'hsCode',
        component: () => import('@/views/Dashboard/HSCode/'),
        props: true
      }
    ]
  },
  {
    path: '/:type(us-customs-import-duty|hts-code)',
    component: () => import('@/views/Layout/'),
    children: [
      {
        path: '',
        name: 'htsHome',
        component: () => import('@/views/HTSCode/')
      },
      // HTS Code
      {
        path: 'search/:query',
        name: 'htsSearchQuery',
        component: () => import('@/views/HTSCode/SearchResults')
      },
      {
        path: 'section/:chapter',
        name: 'htsSectionId',
        component: () => import('@/views/HTSCode/SectionDetails')
      },
      {
        path: 'section/all',
        name: 'htsSectionAll',
        component: () => import('@/views/HTSCode/SectionDetails')
      },
      {
        path: 'products/:keyword?',
        name: 'htsProducts',
        component: () => import('@/views/HTSCode/Keywords')
      },
      {
        path: ':hts2/:hts4/:hts6',
        name: 'hts6',
        component: () => import('@/views/HTSCode/Hts6')
      },
      {
        path: ':hts2/:hts4',
        name: 'hts4',
        component: () => import('@/views/HTSCode/Hts4')
      },
      {
        path: ':hts2',
        name: 'hts2',
        component: () => import('@/views/HTSCode/Hts2')
      }
    ]
  },
  {
    path: '*',
    name: 'Error',
    component: () => import('@/views/ErrorPage/')
  }
]
const router = new VueRouter({
  base: '/',
  mode: 'history',
  routes,
  scrollBehavior() {
    if (document.getElementById('web-container')) {
      document.getElementById('web-container').scrollIntoView()
    }
  }
})

export default router
